module.exports = __webpack_public_path__ + "img/feature-mom.d0d2328f.jpeg";